import _ from "underscore";

/**
 * 获取文件扩展名
 * @param file
 */
export function getExtName(file: string): string {
    if (file.indexOf(".") === -1) return "";
    return file.split(".").pop() || "";
}

/**
 * 文件尺寸格式化
 * @param bytes
 * @param dp
 */
export function humanFileSize(bytes: number, dp = 0) {
    const thresh = 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + " B";
    }

    const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
    );

    return bytes.toFixed(dp) + units[u];
}

export function checkCourseWare(
    file: File,
    TypeList: Record<string, string[]>
) {
    const accept = _.flatten(Object.values(TypeList));
    const MaxFileSize = 1024 * 1024 * 1024; // 附件大小限制500M
    const ext = getExtName(file.name);

    // 校验文件名
    // if (/[\\|/:?*<>]/.test(file.name)) {
    //     throw new Error(file.name + "文件名不能包含以下符号\\|/:?*<>以及\\0");
    // }

    // 校验文件名长度
    if (file.name.length > 200) {
        throw new Error(file.name + "文件名不能超过200个字符");
    }

    // 校验文件类型
    if (!accept.includes(ext?.toLowerCase() || "")) {
        throw new Error(file.name + `该文件格式不允许上传`);
    }

    if (file.size > MaxFileSize) {
        throw new Error(
            file.name +
                `单个文件不能超过${humanFileSize(MaxFileSize)}, 上传失败`
        );
    }
}
